import { render, staticRenderFns } from "./BusinessChangeApplication.vue?vue&type=template&id=7a09df91&scoped=true"
import script from "./BusinessChangeApplication.vue?vue&type=script&lang=js"
export * from "./BusinessChangeApplication.vue?vue&type=script&lang=js"
import style0 from "./BusinessChangeApplication.vue?vue&type=style&index=0&id=7a09df91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a09df91",
  null
  
)

export default component.exports